import * as React from 'react'
import { useNavigate } from 'react-router'
import type { CashMinimal } from '@deposit/api'

const useCashEvents = () => {
    const navigate = useNavigate()

    return React.useCallback(
        (event: CashMinimal) => {
            if (event.status === 'approval') {
                return navigate('/cash-respond', {
                    state: { cash: event },
                })
            }
        },
        [navigate],
    )
}

export default useCashEvents
